import { updateScenarios } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 bg-accent-100 px-3 py-1.5 rounded-full">
            <i className="ri-calendar-line"></i>
            更新说明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            入口发生变化时的常见情形
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            下面列出几种常见的情形，帮助你判断「忽然访问不了」到底意味着什么。
            每一种都对应不同的应对方式，看懂了就不容易慌乱。
          </p>
        </div>

        <div className="mt-10 max-w-4xl">
          <ol className="relative border-l border-background-300/70 pl-6 md:pl-8 space-y-8">
            {updateScenarios.map((item) => (
              <li key={item.title} className="relative">
                <span className="absolute -left-[34px] md:-left-[42px] top-1 w-8 h-8 flex items-center justify-center rounded-full bg-background-50 border border-background-300/70 text-primary-700">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                <div className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6">
                  <span className="inline-flex items-center text-xs text-secondary-700 bg-secondary-100 px-2.5 py-1 rounded-full">
                    {item.tag}
                  </span>
                  <h3 className="mt-3 font-heading text-lg text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-10 max-w-4xl rounded-lg bg-primary-100 border border-primary-200 p-6 md:p-7">
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-notification-3-line text-xl"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg text-primary-950">遇到变动该怎么应对</h3>
              <p className="mt-2 text-sm leading-relaxed text-primary-900/85">
                先接受「地址会变」这个前提，再按顺序处理：确认官方是否发布了新的说明、
                换一条官方通道尝试、实在打不开就稍后再看。整个过程都不需要点击任何来源不明的链接。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}